import React from "react";

interface ShopsAppHeaderProps {
  canCreateShop: boolean;
  onCreateShop: () => void;
}
const ShopsAppHeader = ({
  canCreateShop,
  onCreateShop,
}: ShopsAppHeaderProps) => {
  return (
    <div className="columns">
      <h4 style={{ display: "inline-block" }}>Shops</h4>
      {canCreateShop && (
        <a className="button" style={{ float: "right" }} onClick={onCreateShop}>
          Create Shop
        </a>
      )}
      <a
        className="button alt"
        style={{ float: "right", marginRight: "10px" }}
        target="_blank"
        rel="noopener noreferrer"
        href="https://meetings.hubspot.com/shops/shops-consultation-call"
      >
        Book Shop Talk
      </a>
    </div>
  );
};

export default ShopsAppHeader;
